import dayjs from "dayjs";

const veryPreciseCurrencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 7,
    maximumFractionDigits: 7
});

const preciseCurrencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 4,
    maximumFractionDigits: 4
});

const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

const flexibileFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 1,
    maximumFractionDigits: 4
});

const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

const floatFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

export function formatVeryPreciseCurrency(price) {
    return veryPreciseCurrencyFormatter.format(price);
}

export function formatPreciseCurrency(price) {
    return preciseCurrencyFormatter.format(price);
}

export function formatFlexibibleCurrency(price) {
    return flexibileFormatter.format(price);
}

export function formatCurrency(price) {
    return currencyFormatter.format(price);
}

export function formatNumber(number) {
    return numberFormatter.format(number);
}

export function formatFloat(number) {
    return floatFormatter.format(number);
}

export function formatTime(date) {
    return dayjs(date).format('HH:mm');
}

export function formatDate(date) {
    return dayjs(date).format('DD/MM/YYYY');
}

export function formatLongDate(date) {
    return dayjs(date).format('dddd, MMMM DD, YYYY');
}

export function formatDateTime(date) {
    return dayjs(date).format('DD/MM/YYYY HH:mm');
}

export function formatTokenCount(count) {
    if (count < 1000) return formatNumber(count);
    if (count < 1000000) return (count / 1000).toFixed(1) + "K";
    return (count / 1000000).toFixed(1) + "M";
}

export function formatDuration(seconds) {
    if (seconds < 60) return Math.round(seconds) + " second" + (Math.round(seconds) !== 1 ? "s" : "");
    if (seconds < 3600) return Math.round(seconds / 60) + " minute" + (Math.round(seconds / 60) !== 1 ? "s" : "");
    if (seconds < 86400) return Math.round(seconds / 3600) + " hour" + (Math.round(seconds / 3600) !== 1 ? "s" : "");
    return Math.round(seconds / 86400) + " day" + (Math.round(seconds / 86400) !== 1 ? "s" : "");
}